export function getSysRouter() {
  return request({
    url: '/getRoutersNew',
    method: 'get',
  });
}